<template>
  <v-menu
    v-model="menu"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
    :close-on-content-click="false"
    :nudge-right="40"
  >
    <template v-slot:activator="{ on }">
      <v-text-field v-model="localValue" prepend-icon="event" readonly clearable :label="title" v-on="on" />
    </template>

    <v-date-picker v-model="localValue" locale="pl-pl" :first-day-of-week="1" @input="menu = false" />
  </v-menu>
</template>

<script>
// @vuese
// @group Components/Forms
// Input daty bez schemy
export default {
  props: {
    // Data
    value: {
      type: String,
      required: false
    },
    // tytuł
    title: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      menu: false,
      localValue: this.value
    };
  },
  watch: {
    localValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.localValue = val;
    }
  }
};
</script>
